"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _listSubheaderModule = _interopRequireDefault(require("./list-subheader.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var ListSubheader = function ListSubheader(_ref) {
  var title = _ref.title,
      className = _ref.className;
  return /*#__PURE__*/_react["default"].createElement("h5", {
    className: (0, _classnames["default"])(_listSubheaderModule["default"].listSubHeader, className)
  }, title);
};

ListSubheader.propTypes = {
  className: _propTypes["default"].string,
  title: _propTypes["default"].string.isRequired
};
ListSubheader.defaultProps = {
  className: ''
};
var _default = ListSubheader;
exports["default"] = _default;